import React, { forwardRef, useEffect, useRef } from 'react';
import Logo from '../images/logo512.png';

const Message = forwardRef(({ id, message }, ref) => {
  const localRef = useRef();

  const toastRef = ref || localRef;


  return (
    <>  
      <div className="toast-container position-fixed bottom-0 end-0 p-3">
        <div className="toast" role="alert" aria-live="assertive" aria-atomic="true" id={id} ref={toastRef} >
            <div className="toast-header">
                <strong className="me-auto">System</strong>
                <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div className="toast-body">
                {message ? message : "Hello, world! This is a toast message."}
            </div>
        </div>
      </div>
    </>
  )
});

export default Message;
